import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalHeader.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalHeader.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/elements/modal/ModalHeader.vue?vue&type=script&lang=js&
// module id = 0e8h
// module chunks = 31